module.exports = __webpack_public_path__ + "6a78a6d30b43da9c0093e1ba4f62871d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/jinrong2.png
// module id = 255
// module chunks = 3